
import fakeData from './fakeData.json'
export function configureFakeBackend() {
    let fData = fakeData

    // fetch('./json/fakeData.json').then(response => {
    //     return response.json();
    // }).then(data => {
    //     fData = data;
    // }).catch(err => {
    //     console.log("Error Reading data " + err);
    // });    

    const constants = require("../Config/constants")
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        //const isLoggedIn = opts.headers['Authorization'] === 'Bearer fake-jwt-token';

        return new Promise((resolve) => {
            // wrap in timeout to simulate server api call
            setTimeout(() => {
                // authenticate - public
                if (url.endsWith('/Api/GetProductionOrders') && opts.method === 'GET') {
                    return ok(fData.orders);
                }

                if (url.endsWith('/Api/GetMaterials') && opts.method === 'GET') {
                    return ok(fData.materials);
                }

                if (url.endsWith('/Api/GetArticles') && opts.method === 'GET') {
                    return ok(fData.articles);
                }

                if (url.includes('/Api/PauseOrderById') && opts.method === 'PUT') {
                    fData.orders.find(x => x.id === parseInt(url.charAt(url.length - 1))).state = "paused"
                    return ok(fData.orders);
                }

                if (url.includes('/Api/StartOrderById') && opts.method === 'PUT') {
                    fData.orders.find(x => x.id === parseInt(url.charAt(url.length - 1))).state = "running"
                    return ok(fData.orders);
                }

                if (url.endsWith('/Api/GetTransportOrdersHistory') && opts.method === 'GET') {

                    return ok(fData.transportOrdersHistory);
                }

                if (url.endsWith('/Api/GetActiveTransportOrders') && opts.method === 'GET') {

                    return ok(fData.activeTransportOrders);
                }

                if (url.endsWith('/Api/CreateNewBooking') && opts.method === 'POST') {

                    return ok([]);
                }

                if (url.endsWith('/Api/GetSilos') && opts.method === 'GET') {

                    return ok(fData.silos);
                }

                if (url.includes("token")) {
                    if (opts.body.get("username") === constants.loginUserName && opts.body.get("password") === constants.loginPassWord) {
                        return ok(fData.userInfo)
                    }
                    else {
                        return resolve({ ok: false, status:401,text: () => Promise.resolve(constants.defaultAuthenticationErrorMessage)})
                    }
                }

               
                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 6));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=7') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 7));
                // }

                if (url.includes('/Api/GetQualityChecksByOrderId') && opts.method === 'GET') {

                    let orderId = 0;
                    if (parseInt(url.charAt(url.length - 1)) > 0) {
                        orderId = parseInt(url.charAt(url.length - 1))
                    }
                    else {
                        orderId = (parseInt(url.charAt(url.length - 2)) * 10) + parseInt(url.charAt(url.length - 1))
                    }

                    return ok(fData.qualitychecks.filter(x => x.orderId === orderId));
                }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=8') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 8));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=9') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 9));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=10') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 10));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=11') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 11));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=12') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 12));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 6));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 6));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fData.qualitychecks.filter(x => x.orderId === 6));
                // }


                if (url.endsWith('/Api/GetOperators') && opts.method === 'GET') {
                    return ok(fData.operators);
                }

                if (url.endsWith('/Api/GetQualityCheckSteps') && opts.method === 'GET') {
                    return ok(fData.qualityCheckSteps);
                }

                if (url.endsWith('/Api/GetMachineParameters') && opts.method === 'GET') {
                    return ok(fData.machineParameters);
                }

                if (url.endsWith('/Api/GetWorkstations') && opts.method === 'GET') {
                    return ok(fData.workstations);
                }

                if (url.endsWith('/Api/GetWorkstationStatusses') && opts.method === 'GET') {
                    return ok(fData.workstationStatusses);
                }

                if (url.endsWith('/Api/GetShifts') && opts.method === 'GET') {
                    return ok(fData.shifts);
                }

                if (url.endsWith('/Api/GetProgressions') && opts.method === 'GET') {
                    return ok(fData.progressions);
                }

                if (url.endsWith('/Api/GetRestrictions') && opts.method === 'GET') {
                    return ok(fData.restrictions);
                }

                if (url.endsWith('/Api/GetWorkingHours') && opts.method === 'GET') {
                    return ok(fData.workingHours);
                }

                if (url.endsWith('/Api/GetRestrictionTypes') && opts.method === 'GET') {
                    return ok(fData.restrictionTypes);
                }

                if (url.endsWith('/Api/GetQualityChecks') && opts.method === 'GET') {
                    return ok(fData.qualityChecks);
                }

                if (url.endsWith('/Api/GetQualityCheckTypes') && opts.method === 'GET') {
                    return ok(fData.qualityCheckTypes);
                }

                if (url.endsWith('/Api/GetQualityCheckOrders') && opts.method === 'GET') {
                    return ok(fData.qualityCheckOrders);
                }

                // get users - secure
                // if (url.endsWith('/users') && opts.method === 'GET') {
                //     if (!isLoggedIn) return unauthorised();
                //     return ok(users);
                // }

                // pass through any requests not handled above
                //console.log(url)
                realFetch(url, opts).then(response => resolve(response));

                // private helper functions

                function ok(body) {
                    resolve({ ok: true, text: () => Promise.resolve(JSON.stringify({ body })) })
                }


                // function unauthorised() {
                //     resolve({ status: 401, text: () => Promise.resolve(JSON.stringify({ message: 'Unauthorised' })) })
                // }

                // function error(message) {
                //     resolve({ status: 400, text: () => Promise.resolve(JSON.stringify({ message })) })
                // }
            }, 500);
        });
    }
}

